import moment from "moment";
import React from "react";
import { getWeekColumnData } from "../../../../../utils/annual-planner-helpers";
import { PhaseColumn } from "./";

export const PhaseCard = ({
  month,
  numberOfWeeks,
  phases,
  startingCalendarDay,
  phasesAttachments,
  handlePhaseSelection,
}) => {
  const exactMonth = `${moment(month).format("YYYYMM")}`;

  return (
    <div className="phase-card">
      {Array.from(Array(numberOfWeeks).keys(), (weekNumber, index) => {
        ++weekNumber;
        const exactWeek = `${exactMonth}-${weekNumber}`;
        const weekFirstDay = getWeekColumnData(
          month,
          startingCalendarDay,
          weekNumber - 1
        );
        return (
          //   The phase column contains one checkbox per each training phase
          <PhaseColumn
            key={`phase-column-${index}-${Math.random().toString(16).slice(2)}`}
            weekFirstDay={weekFirstDay}
            exactWeek={exactWeek}
            phases={phases}
            handlePhaseSelection={handlePhaseSelection}
            phasesAttachments={phasesAttachments}
          />
        );
      })}
    </div>
  );
};
